/* eslint-disable no-undef */
/* eslint-disable no-undef */
<template>
    <div>
        <!-- Home Start-->
        <section class="main-header bg-header">
            <div class="home-bg-img" >
                <div class="container" >
                    <div class="owl-carousel owl-theme main-slider">
                        <div class="item">
                            <div class="row align-items-center">
                                <div class="col-lg-7">
                                    <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                        <h1 class="banner-title text-lg-left text-center text-white text-uppercase">
                                            WIZ
                                        </h1> 
                                        <h2 class="banner-title text-lg-left text-center text-white text-uppercase">
                                            Readymade technology
                                        </h2>                                        
                                        <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                           Somos un grupo de personas buscando compartir experiencias profesionales con nuestro entorno, deseando dar ese extra, enfocados en enriquecer nuestro servicio e innovando en formas de como potencializar las fortalezas de nuestros clientes.
                                        </p>
                                        <!--<div class="mt-md-4 mb-4 text-lg-left text-center">
                                            <a href="#" class="btn theme-btn text-white">EMPEZAR</a>
                                        </div>-->
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <div class="banner-img-02 wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                        <!--<img src="assets/images/main-banner-01.png" class="img-fluid" alt="">-->
                                        <img src="@/assets/images/wiz-image/isologoRGBWIZ.png" class="img-fluid" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="item">
                            <div class="row align-items-center">
                                <div class="col-lg-7">
                                    <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                        <h2 class="banner-title text-lg-left text-center text-white text-uppercase">
                                            Wiz Readymade technology briefing
                                        </h2>
                                        <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                            simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <div class="mt-md-4 mb-4 text-lg-left text-center">
                                            <a href="#" class="btn theme-btn text-white">GET STARTED</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <div class="banner-img-02 wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                        <img src="assets/images/main-banner-01.png" class="img-fluid" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="row align-items-center">
                                <div class="col-lg-7">
                                    <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                        <h2 class="banner-title text-lg-left text-center text-white text-uppercase">
                                            Wiz Readymade technology briefing
                                        </h2>
                                        <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                            simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <div class="mt-md-4 mb-4 text-lg-left text-center">
                                            <a href="#" class="btn theme-btn text-white">GET STARTED</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <div class="banner-img-02 wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                        <img src="assets/images/main-banner-01.png" class="img-fluid" alt="">
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </section>
        <!-- Home End -->
        <!-- Start Aboutus -->
        <section class="section bg-white">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-lg-0 mt-sm-4 mt-0">
                            <div class="hover-block aboutus-inner transition p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="about-inner-main text-center">
                                    <div class="about-inner-text">
                                        <h2 class="f-40 theme-color text-md-left text-center">01.</h2>
                                        <h5 class="my-3 theme-color text-md-left text-center font-weight-medium">Software & Tecnologia</h5>
                                        <p class="para-text text-md-left text-center mb-0">Desarrollo de productos & plataformas digitales que promueven transformación digital, tecnología lista para transicionar empresas a un ecosistema digital en un periodo de tiempo corto.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-lg-0 mt-4">
                            <div class="hover-block aboutus-inner transition p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="about-inner-main text-center">
                                    <div class="about-inner-text">
                                        <h2 class="f-40 theme-color text-md-left text-center">02.</h2>
                                        <h5 class="my-3 theme-color text-md-left text-center font-weight-medium">Transformación de procesos de negocio + Tecnología</h5>
                                        <p class="para-text text-md-left text-center mb-0">Acompañamiento en el rediseño y mejora de procesos escalables y repetibles basados  en las prácticas lideres de la industria con la aplicación de tecnología</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="col-lg-4 col-sm-6">
                        <div class="mt-lg-0 mt-4">
                            <div class="hover-block aboutus-inner transition p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="about-inner-main text-center">
                                    <div class="about-inner-text">
                                        <h2 class="f-40 theme-color text-md-left text-center">03.</h2>
                                        <h5 class="my-3 theme-color text-md-left text-center font-weight-medium">Launch Website</h5>
                                        <p class="para-text text-md-left text-center mb-0">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
                <div class="about-bottom-section mt-5 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">ACERCA</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-40">Acerca de Productos y Servicios</h2>
                    </div>
                    <div class="mt-4">
                        <div class="row align-items-center">
                            <div class="col-lg-5">
                                <img src="@/assets/images/wiz-image/square_v1.png" alt="wizimg2.png" class="w-100 img-fluid" width="" >
                                <!--<img src="assets/images/aboutus/about-img.png" alt="about-img.png" class="w-100 img-fluid">-->
                            </div>
                            <div class="col-lg-7 mt-lg-0 mt-4">
                                <h1 class="font-sm-24">Producto Digital</h1>
                                <!--<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution.</p>-->
                                <ul class="about-list list-unstyled pl-4 mb-0">
                                    <li class="position-relative mb-4"><h4>STOCK RUSH</h4></li>
                                        <p>-De la orden da la cobranza</p>
                                        <pre>  - Manejo de Ordernes</pre>
                                        <pre>  - Surtido de ordenes de embarque</pre>
                                        <pre>  - Procesamiento de embarques</pre>
                                        <pre>  - Control de Inventarios</pre>
                                        <p>- Catálogo de Productos</p>
                                        <p>- Catálogo de Clientes</p>
                                        <p>- Control de órdenes de trabajo</p>
                                    <!--<li class="position-relative mb-4">Procesos de negocios(Transformacion + Tecnologia).</li>
                                        <p>Implementacion de procesos escalables y repetibles basados en las practicas lideres de la insdustria apoyados por la utilizacion de tecnologia.</p>
                                        <p>Mejoras en procesos especificos claves en un periodo de tiempo de 4 a 6 semanas son resultados tangibles.</p>
                                    <li class="position-relative">It is a long established fact that a reader will be distracted by the readable.</li>-->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Aboutus -->
        <!-- Start Features section -->
        <section class="section bg-light">
            <div class="container">
                <div class="title-section">
                    <div class="subtitle-hr d-flex align-items-center">
                        <h6 class="subtitle theme-color text-uppercase position-relative">SERVICIOS</h6>
                        <hr>
                    </div>
                    <h2 class="title text-md-left text-center f-40">Transformación de Procesos de negocios</h2>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-main text-center">
                                    <div class="features-inner-text text-sm-left text-center">
                                        <div class="icon-block theme-bg d-inline-block rounded-circle p-3">
                                            <span class="icon transition mdi mdi-package-variant d-flex align-items-center justify-content-center text-white f-40"></span>
                                        </div>
                                        <h5 class="my-3 theme-color text-sm-left text-center font-weight-medium">Control de Inventarios</h5>
                                        <p class="para-text text-sm-left text-center mb-0">- Veracidad de inventario arriba del 98%.</p>
                                        <p class="para-text text-sm-left text-center mb-0">- Auditorias del inventario físico periódico.</p>
                                        <p class="para-text text-sm-left text-center mb-0">- Aseguramiento y auditoria de transición de inventario entre áreas físicas.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <div class="icon-block theme-bg d-inline-block rounded-circle p-3">
                                        <span class="icon transition mdi mdi-account-hard-hat d-flex align-items-center justify-content-center text-white f-40"></span>
                                    </div>
                                    <h5 class="my-3 theme-color text-sm-left text-center font-weight-medium">Control de Producción</h5>
                                    <p class="para-text text-sm-left text-center mb-0">- Control de órdenes de trabajo (status y consumo de materia prima).</p>
                                    <p class="para-text text-sm-left text-center mb-0">- Contabilización de producto terminado.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <div class="icon-block theme-bg d-inline-block rounded-circle p-3">
                                        <span class="icon transition mdi mdi-truck-delivery-outline d-flex align-items-center justify-content-center text-white f-40"></span>
                                    </div>
                                    <h5 class="my-3 theme-color text-sm-left text-center font-weight-medium">Surtido de Órdenes</h5>
                                    <p class="para-text text-sm-left text-center mb-0">- On time delivery (Mejora en el indicador de entregas a tiempo).</p>
                                    <p class="para-text text-sm-left text-center mb-0">- Monitoreo de órdenes de principio a fin.</p>
                                    <p class="para-text text-sm-left text-center mb-0">- Descarga de inventario de producto en tiempo real</p>
                                    <p class="para-text text-sm-left text-center mb-0">- Análisis de factibilidad en la entrega de acuerdo al inventario disponible.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="col-lg-4 col-sm-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <div class="icon-block theme-bg d-inline-block rounded-circle p-3">
                                        <span class="icon transition mdi mdi-chat-processing d-flex align-items-center justify-content-center text-white f-40"></span>
                                    </div>
                                    <h5 class="my-3 theme-color text-sm-left text-center font-weight-medium">Chatting Service</h5>
                                    <p class="para-text text-sm-left text-center mb-0">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <div class="icon-block theme-bg d-inline-block rounded-circle p-3">
                                        <span class="icon transition mdi mdi-chart-areaspline d-flex align-items-center justify-content-center text-white f-40"></span>
                                    </div>
                                    <h5 class="my-3 theme-color text-sm-left text-center font-weight-medium">Analysis</h5>
                                    <p class="para-text text-sm-left text-center mb-0">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <div class="icon-block theme-bg d-inline-block rounded-circle p-3">
                                        <span class="icon transition  mdi mdi-face-agent d-flex align-items-center justify-content-center text-white f-40"></span>
                                    </div>
                                    <h5 class="my-3 theme-color text-sm-left text-center font-weight-medium">Quick Support</h5>
                                    <p class="para-text text-sm-left text-center mb-0">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </section>
        <!-- End Features section -->
        <!-- Start How it Works section -->
        <section class="section">
            <div class="container">
                <div class="row align-items-center">
                    <!--<div class="col-lg-6">
                        <div class="bs-example position-relative wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1s">
                            <img id="video-cover" src="assets/images/how-it-works/01.png" alt="Video title" class="w-100 img-fluid">
                            <a href="#myModal" class="play-btn transition d-flex" data-toggle="modal">
                                <i class="mdi mdi-play mx-auto"></i>
                            </a>

                            <div id="myModal" class="modal wow fadeIn" data-wow-delay="0.2s" data-wow-duration="1s">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content bg-transparent">
                                        <div class="modal-body p-0">
                                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><span>&times;</span></button>
                                            <iframe src="https://www.youtube.com/embed/Kch8n4tcOZQ" allowfullscreen></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <div class="col-lg-6 mt-lg-0 mt-4">
                        <div class="title-section">
                            <div class="subtitle-hr d-flex align-items-center">
                                <h6 class="subtitle theme-color text-uppercase position-relative">Etapas</h6>
                                <hr>
                            </div>
                            <h2 class="title text-md-left text-center f-40">¿Como funciona?</h2>
                        </div>
                        <div class="text-md-left text-center">
                            <p>Implementación de procesos escalables y repetibles basados en las prácticas lideres de la industria apoyados por la utilización de tecnología.</p>
                            <p class="mb-0">Mejoras en procesos específicos claves en un periodo de tiempo de 4 a 6 semanas con resultados tangibles. </p>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-4 col-sm-6 mt-lg-4 mt-4 block-item">
                                <div class="row align-items-center">
                                    <div class="col-lg-2">
                                        <div class="d-inline-block text-lg-left text-center w-100">
                                            <div class="icon-block transition circle-outline d-flex justify-content-center align-items-center rounded-circle p-3 mx-auto">
                                                <span class="icon transition mdi mdi-airplane-takeoff d-flex align-items-center justify-content-center theme-color f-40"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="d-inline-block text-lg-left text-center">
                                            <h6 class="theme-color f-20 my-lg-2 my-3">Introducción & Mapeo Inicial</h6>
                                            <!--<p class="m-0">
                                                It is a long established fact that a reader will be distracted by
                                                the readable content of a page when looking at its layout.
                                            </p>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-4 col-sm-6 mt-lg-4 mt-4 block-item">
                                <div class="row align-items-center">
                                    <div class="col-lg-2">
                                        <div class="d-inline-block text-lg-left text-center w-100">
                                            <div class="icon-block transition circle-outline d-flex justify-content-center align-items-center rounded-circle p-3 mx-auto">
                                                <span class="icon transition mdi mdi-factory d-flex align-items-center justify-content-center theme-color f-40"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="d-inline-block text-lg-left text-center">
                                            <h6 class="theme-color f-20 my-lg-2 my-3">Mapeo por área física, diagramas de flujo de material y de proceso</h6>
                                            <!--<p class="m-0">
                                                It is a long established fact that a reader will be distracted by
                                                the readable content of a page when looking at its layout.
                                            </p>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-4 col-sm-6 mt-lg-4 mt-4 block-item mx-auto">
                                <div class="row align-items-center">
                                    <div class="col-lg-2">
                                        <div class="d-inline-block text-lg-left text-center w-100">
                                            <div class="icon-block transition circle-outline d-flex justify-content-center align-items-center rounded-circle p-3 mx-auto">
                                                <span class="icon transition mdi mdi-test-tube d-flex align-items-center justify-content-center theme-color f-40"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="text-lg-left text-center my-lg-0">
                                            <h6 class="theme-color f-20 my-lg-2 my-3">Entrenamiento, Pruebas, Documentación y preparación de áreas físicas.</h6>
                                            <!--<p class="m-0">
                                                It is a long established fact that a reader will be distracted by
                                                the readable content of a page when looking at its layout.
                                            </p>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-4 col-sm-6 mt-lg-4 mt-4 block-item mx-auto">
                                <div class="row align-items-center">
                                    <div class="col-lg-2">
                                        <div class="d-inline-block text-lg-left text-center w-100">
                                            <div class="icon-block transition circle-outline d-flex justify-content-center align-items-center rounded-circle p-3 mx-auto">
                                                <span class="icon transition mdi mdi-rocket d-flex align-items-center justify-content-center theme-color f-40"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="text-lg-left text-center my-lg-0">
                                            <h6 class="theme-color f-20 my-lg-2 my-3">Pilotos y ajustes refinamiento de KPI y reporteo ejecutivo.</h6>
                                            <!--<p class="m-0">
                                                It is a long established fact that a reader will be distracted by
                                                the readable content of a page when looking at its layout.
                                            </p>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-4 col-sm-6 mt-lg-4 mt-4 block-item mx-auto">
                                <div class="row align-items-center">
                                    <div class="col-lg-2">
                                        <div class="d-inline-block text-lg-left text-center w-100">
                                            <div class="icon-block transition circle-outline d-flex justify-content-center align-items-center rounded-circle p-3 mx-auto">
                                                <span class="icon transition mdi mdi-slope-uphill d-flex align-items-center justify-content-center theme-color f-40"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="text-lg-left text-center my-lg-0">
                                            <h6 class="theme-color f-20 my-lg-2 my-3">Rampeo y estabilización.</h6>
                                            <!--<p class="m-0">
                                                It is a long established fact that a reader will be distracted by
                                                the readable content of a page when looking at its layout.
                                            </p>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-4 col-sm-6 mt-lg-4 mt-4 block-item mx-auto">
                                <div class="row align-items-center">
                                    <div class="col-lg-2">
                                        <div class="d-inline-block text-lg-left text-center w-100">
                                            <div class="icon-block transition circle-outline d-flex justify-content-center align-items-center rounded-circle p-3 mx-auto">
                                                <span class="icon transition mdi mdi-flag-checkered d-flex align-items-center justify-content-center theme-color f-40"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-10">
                                        <div class="text-lg-left text-center my-lg-0">
                                            <h6 class="theme-color f-20 my-lg-2 my-3">Entrega y cierre de proyecto.</h6>
                                            <!--<p class="m-0">
                                                It is a long established fact that a reader will be distracted by
                                                the readable content of a page when looking at its layout.
                                            </p>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End How it Works section -->
        <!-- Start FAQ's And Meet Our Team -->
        <!--
        <section class="section bg-light">
            <div class="container">
                <div class="row align-items-baseline">
                    <div class="col-lg-6 wow fadeInUp" data-wow-duration="1500ms">
                        <div class="title-section">
                            <div class="subtitle-hr d-flex align-items-center">
                                <h6 class="subtitle theme-color text-uppercase position-relative">FAQ's</h6>
                                <hr>
                            </div>
                            <h2 class="title text-md-left text-center f-40">Ask Question?</h2>
                        </div>
                        <div class="mt-4">
                            <div id="accordion" class="wow fadeInUp" data-wow-duration="1500ms">
                                <div class="accordion-card bg-white mb-4 shadow rounded active">
                                    <div class="card-header border-0 p-0" id="headingOne">
                                        <h5 class="mb-0">
                                            <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"><span class="font-weight-medium"> Made With Love</span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                        </h5>
                                    </div>
                                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                        <div class="pt-2">
                                            <p class="m-0">
                                                It is a long established fact that a reader will be distracted by the read able content of a page when looking at its layout.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-card bg-white mb-4 shadow rounded">
                                    <div class="card-header border-0 p-0" id="headingTwo">
                                        <h5 class="mb-0">
                                            <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"><span class="font-weight-medium"> Made With Love?</span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                        </h5>
                                    </div>
                                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                        <div class="pt-2">
                                            <p class="m-0">
                                                It is a long established fact that a reader will be distracted by the read able content of a page when looking at its layout.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-card bg-white mb-4 shadow rounded">
                                    <div class="card-header border-0 p-0" id="headingThree">
                                        <h5 class="mb-0">
                                            <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"><span class="font-weight-medium"> Made With Love?</span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                        </h5>
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                        <div class="pt-2">
                                            <p class="m-0">
                                                It is a long established fact that a reader will be distracted by the read able content of a page when looking at its layout.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-card bg-white mb-4 shadow rounded">
                                    <div class="card-header border-0 p-0" id="headingFour">
                                        <h5 class="mb-0">
                                            <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour"><span class="font-weight-medium"> Made With Love?</span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                        </h5>
                                    </div>
                                    <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                                        <div class="pt-2">
                                            <p class="m-0">
                                                It is a long established fact that a reader will be distracted by the read able content of a page when looking at its layout.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mt-lg-0 mt-4">
                        <div class="wow fadeInUp" data-wow-duration="1500ms">
                            <div class="title-section">
                                <div class="subtitle-hr d-flex align-items-center">
                                    <h6 class="subtitle theme-color text-uppercase position-relative">TEAM</h6>
                                    <hr>
                                </div>
                                <h2 class="title text-md-left text-center f-40">Meet our Team</h2>
                            </div>
                        </div>
                        <div class="mt-4 wow fadeInUp" data-wow-duration="1500ms">
                            <div class="row team-slider owl-carousel owl-theme">
                                <div class="col-12">
                                    <div class="border bg-white transition text-center p-3">
                                        <div class="rounded-circle overflow-hidden team-img mx-auto">
                                            <img src="assets/images/team/team-01.jpg" class="rounded-circle img-fluid" alt="team-01.jpg">
                                        </div>
                                        <div class="team-desc">
                                            <h6 class="f-18 my-2 theme-color">David Joe</h6>
                                            <p class="my-2 f-16">Company CEO</p>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-facebook transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-twitter transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-google-plus transition f-34"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="border bg-white transition text-center p-3">
                                        <div class="rounded-circle overflow-hidden team-img mx-auto">
                                            <img src="assets/images/team/team-02.jpg" class="rounded-circle img-fluid" alt="team-02.jpg">
                                        </div>
                                        <div class="team-desc">
                                            <h6 class="f-18 my-2 theme-color">David Joe</h6>
                                            <p class="my-2 f-16">Company CEO</p>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-facebook transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-twitter transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-google-plus transition f-34"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="border bg-white transition text-center p-3">
                                        <div class="rounded-circle overflow-hidden team-img mx-auto">
                                            <img src="assets/images/team/team-01.jpg" class="rounded-circle img-fluid" alt="team-01.jpg">
                                        </div>
                                        <div class="team-desc">
                                            <h6 class="f-18 my-2 theme-color">David Joe</h6>
                                            <p class="my-2 f-16">Company CEO</p>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-facebook transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-twitter transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-google-plus transition f-34"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="border bg-white transition text-center p-3">
                                        <div class="rounded-circle overflow-hidden team-img mx-auto">
                                            <img src="assets/images/team/team-02.jpg" class="rounded-circle img-fluid" alt="team-02.jpg">
                                        </div>
                                        <div class="team-desc">
                                            <h6 class="f-18 my-2 theme-color">David Joe</h6>
                                            <p class="my-2 f-16">Company CEO</p>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-facebook transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-twitter transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-google-plus transition f-34"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="border bg-white transition text-center p-3">
                                        <div class="rounded-circle overflow-hidden team-img mx-auto">
                                            <img src="assets/images/team/team-01.jpg" class="rounded-circle img-fluid" alt="team-02.jpg">
                                        </div>
                                        <div class="team-desc">
                                            <h6 class="f-18 my-2 theme-color">David Joe</h6>
                                            <p class="my-2 f-16">Company CEO</p>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-facebook transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-twitter transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-google-plus transition f-34"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="border bg-white transition text-center p-3">
                                        <div class="rounded-circle overflow-hidden team-img mx-auto">
                                            <img src="assets/images/team/team-02.jpg" class="rounded-circle img-fluid" alt="team-02.jpg">
                                        </div>
                                        <div class="team-desc">
                                            <h6 class="f-18 my-2 theme-color">David Joe</h6>
                                            <p class="my-2 f-16">Company CEO</p>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-facebook transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-twitter transition f-34"></i>
                                            </a>
                                            <a href="#" class="mx-2 d-inline-block social-icon transition">
                                                <i class="mdi theme-color mdi-google-plus transition f-34"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        -->
        <!-- End FAQ's -->
        <!-- Start Clients Section -->
        <!--
        <section class="clients-section section">
            <div class="container">
                <div class="title-section z-index position-relative wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="subtitle-hr d-flex align-items-center">
                        <h6 class="subtitle text-white text-uppercase position-relative">TESTIMONIALS</h6>
                        <hr class="white-border">
                    </div>
                    <h2 class="title text-md-left text-center f-40 text-white">Client Says</h2>
                </div>
                <div class="mt-4 owl-carousel owl-theme clients-slider wow fadeIn" data-wow-duration="1000ms">
                    <div class="px-3 item wow fadeIn" data-wow-delay="0.2s" data-wow-duration="1s">
                        <div class="user-pics overflow-hidden mx-auto">
                            <img src="assets/images/clients/client-01.png" alt="" class="img-fluid">
                        </div>
                        <div class="clients-card bg-white">
                            <div class="user-txt text-sm-left text-center">
                                <div class="use-info">
                                    <h5 class="theme-color">Alee Tie</h5>
                                    <p class="f-14">Company CEO</p>
                                </div>
                            </div>
                            <div class="shadow-md">
                                <p class="m-0 text-sm-left text-center f-16 font-weight-medium"><em> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. the readable content of a page when looking at its layout.</em> </p>
                            </div>
                        </div>
                    </div>
                    <div class="px-3 item wow fadeIn" data-wow-delay="0.3s" data-wow-duration="1s">
                        <div class="user-pics overflow-hidden mx-auto">
                            <img src="assets/images/clients/client-02.png" alt="" class="img-fluid">
                        </div>
                        <div class="clients-card bg-white">
                            <div class="user-txt text-sm-left text-center">
                                <div class="use-info">
                                    <h5 class="theme-color">Kalvin Stafrd</h5>
                                    <p class="f-14">Company CEO</p>
                                </div>
                            </div>
                            <div class="shadow-md">
                                <p class="m-0 text-sm-left text-center f-16 font-weight-medium"><em> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. the readable content of a page when looking at its layout.</em> </p>
                            </div>
                        </div>
                    </div>
                    <div class="px-3 item wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1s">
                        <div class="user-pics overflow-hidden">
                            <img src="assets/images/clients/client-03.png" alt="" class="img-fluid">
                        </div>
                        <div class="clients-card bg-white">
                            <div class="user-txt text-sm-left text-center">
                                <div class="use-info">
                                    <h5 class="theme-color">Elie Johnson</h5>
                                    <p class="f-14">Company CEO</p>
                                </div>
                            </div>
                            <div class="shadow-md">
                                <p class="m-0 text-sm-left text-center f-16 font-weight-medium"><em> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. the readable content of a page when looking at its layout.</em> </p>
                            </div>
                        </div>
                    </div>
                    <div class="px-3 item wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1s">
                        <div class="user-pics overflow-hidden mx-auto">
                            <img src="assets/images/clients/client-02.png" alt="" class="img-fluid">
                        </div>
                        <div class="clients-card bg-white">
                            <div class="user-txt text-sm-left text-center">
                                <div class="use-info">
                                    <h5 class="theme-color">Elie Johnson</h5>
                                    <p class="f-14">Company CEO</p>
                                </div>
                            </div>
                            <div class="shadow-md">
                                <p class="m-0 text-sm-left text-center f-16 font-weight-medium"><em> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. the readable content of a page when looking at its layout.</em> </p>
                            </div>
                        </div>
                    </div>
                    <div class="px-3 item wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1s">
                        <div class="user-pics overflow-hidden mx-auto">
                            <img src="assets/images/clients/client-01.png" alt="" class="img-fluid">
                        </div>
                        <div class="clients-card bg-white">
                            <div class="user-txt text-sm-left text-center">
                                <div class="use-info">
                                    <h5 class="theme-color">Elie Johnson</h5>
                                    <p class="f-14">Company CEO</p>
                                </div>
                            </div>
                            <div class="shadow-md">
                                <p class="m-0 text-sm-left text-center f-16 font-weight-medium"><em> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. the readable content of a page when looking at its layout.</em> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        -->
        <!-- End Clients Section -->
        <!-- Satrt Contact us -->
        <section class="section contactus-section">
            <div class="container">
                <div class="title-section wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="subtitle-hr d-flex align-items-center">
                        <h6 class="subtitle theme-color text-uppercase position-relative">CONTACTO</h6>
                        <hr>
                    </div>
                    <h2 class="title text-md-left text-center f-40">Contáctanos</h2>
                </div>
                <div class="wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-md-12 col-sm-4 py-sm-4 contact-item">
                                    <div class="row align-items-center">
                                        <div class="col-lg-2 col-md-3">
                                            <div class="text-md-left text-center">
                                                <div class="icon-block transition bg-light d-inline-block rounded-circle p-3">
                                                    <span class="icon mdi mdi-map-marker d-flex align-items-center justify-content-center theme-color transition"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-10 col-md-9">
                                            <div class="text-md-left text-center mt-lg-0 mt-4">
                                                <h5 class="theme-color f-20">Ubicación</h5>
                                                <a class="text-dark text-chat" href="https://www.google.com/maps" target="_blank">
                                                    Enrique Díaz de Leon sur 596, Colonia Americana, Guadalajara Jal. 44190
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-4 col-6 py-4 contact-item">
                                    <div class="row align-items-center">
                                        <div class="col-lg-2 col-md-3">
                                            <div class="text-md-left text-center">
                                                <div class="icon-block transition bg-light d-inline-block rounded-circle p-3">
                                                    <span class="icon  mdi mdi-email d-flex align-items-center justify-content-center theme-color transition"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-10 col-md-9">
                                            <div class="text-md-left text-center mt-lg-0 mt-4">
                                                <h5 class="theme-color f-20">Email</h5>
                                                <a href="mailto:contacto@wizrm.com" class="text-dark text-chat">contacto@wizrm.com</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="col-md-12 col-sm-4 col-6 py-4 contact-item">
                                    <div class="row align-items-center">
                                        <div class="col-lg-2 col-md-3">
                                            <div class="text-md-left text-center">
                                                <div class="icon-block transition bg-light d-inline-block rounded-circle p-3">
                                                    <span class="icon  mdi mdi-email d-flex align-items-center justify-content-center theme-color transition"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-<div class="col-lg-10 col-md-9">
                                            <div class="text-md-left text-center mt-lg-0 mt-4">
                                                <h5 class="theme-color f-20">Call:</h5>
                                                <a href="tel:" class="text-dark text-chat"></a>
                                                <a href="x" class="text-dark text-chat">+52 333 476 8842</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-7">
                            <form class="contact_form common-input-form mt-md-4" v-on:submit.prevent="submit">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="name" v-model="form.name" id="name" type="text" class="form-control border-0" placeholder="Nombre">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="email" v-model="form.email" id="email" type="email" class="form-control border-0" placeholder="Correo">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <input name="subject" v-model="form.subject" id="subject" type="text" class="form-control border-0" placeholder="Asunto">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <textarea name="comments" v-model="form.message" id="comments" rows="6" class="form-control border-0" placeholder="Mensaje"></textarea>
                                        </div>
                                         <div class="form-group">
                                            <label for="robot" class="col-sm-2 col-form-label"></label>
                                            <div class="col-sm-10">
                                            <vue-recaptcha ref="recaptcha"
                                                @verify="onVerify" sitekey="6LeOWDwaAAAAAHdm1cQvbU8zj4-TzSrw9iGCVGxT">
                                                </vue-recaptcha>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 text-left">
                                        <button v-if="form.robot" type="submit" class="mt-4 btn theme-btn contact-form-btn border-0" value="Send">Send</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Contact us -->
    </div>
</template>
<script>
    //WOW JS
    import { WOW } from 'wowjs';
    //OWL CAROUSEL JS
    import 'owl.carousel/dist/assets/owl.carousel.css';
    import 'owl.carousel';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: 'index', mounted() {
            this.init();
        },  
         components: {
            VueRecaptcha
        },
        data(){
            return {
                form: {
                    name:'',
                    email: '',
                    subject: '',
                    message: '',
                    robot: false
                }
            }
        },
        methods: {
            submit(){   
                if(this.form.robot){
                    fetch('https://hooks.slack.com/services/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', {
                        method: 'POST',
                        mode:'no-cors',
                        headers:{
                            'Content-type': 'application/json'
                        }, 
                        body: JSON.stringify({
                            "text": `--------------------------------\nName:${this.form.name}\nEmail:${this.form.email}\nSubject:${this.form.subject}\nMessage:${this.form.message}\n------------------------------------\n `
                        })
                    // eslint-disable-next-line no-unused-vars
                    }).then(res => {                    
                        this.form.name = ''
                        this.form.email = ''
                        this.form.subject = ''
                        this.form.message = ''
                    })
                    this.form.robot = false
                    this.$refs.recaptcha.reset();
                }
            },
            init() {
                this.initMainSlider();
                this.initWowAnimation();
                this.initTeamSlider();
                this.initClientSlider();
                this.initAccordian();
            },
            onVerify(response){
                if(response) this.form.robot = true;
            },
            /*----Main Slider----*/
            initMainSlider() {
                // eslint-disable-next-line no-undef
                $('.main-slider').owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,                    
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        1000: {
                            items: 1,
                            nav: false,
                            dots: true
                        }
                    }
                });
            },
            /*----WOW ANIMATION-----*/
            initWowAnimation() {
                var length = $('.wow').length;
                if (length >= 1) {
                    const wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: 0,
                    });
                    wow.init();
                }
            },
            /*----TEAM SLIDER-----*/
            initTeamSlider() {
                var teamCarousel = $('.team-slider');
                if (teamCarousel.length > 0) {
                    teamCarousel.owlCarousel({
                        loop: true,
                        items: 1,
                        margin: 0,
                        nav: true,
                        dots: true,
                        autoplay: false,
                        autoplayTimeout: 5000,
                        items: 2,
                        responsiveClass: true,
                        responsive: {
                            0: {
                                items: 1,
                                nav: false,
                                dots: true
                            },
                            600: {
                                items: 1,
                                nav: false,
                                dots: true
                            },
                            991: {
                                items: 2,
                                nav: false,
                                dots: true
                            }
                        }
                    });
                }
            },
            /*----CLIENT SLIDER-----*/
            initClientSlider() {
                var testimonialCarousel = $('.clients-slider');
                if (testimonialCarousel.length > 0) {
                    testimonialCarousel.owlCarousel({
                        loop: true,
                        items: 1,
                        margin: 0,
                        nav: true,
                        dots: true,
                        autoplay: false,
                        autoplayTimeout: 5000,
                        items: 2,
                        responsiveClass: true,
                        responsive: {
                            0: {
                                items: 1,
                                nav: false,
                                dots: true
                            },
                            600: {
                                items: 1,
                                nav: false,
                                dots: true
                            },
                            991: {
                                items: 2,
                                nav: false,
                                dots: true
                            }
                        }
                    });
                }
            },
            /*----ACCORDIAN-----*/
            initAccordian() {
                $(".accordion-card").click(function () {
                    if ($(this).hasClass('active')) {
                        $('.accordion-card').removeClass('active');
                        $(this).removeClass('active')
                    } else {
                        $('.accordion-card').removeClass('active');
                        $(this).addClass('active')
                    }
                });
            }
        }
    }
</script>